'use client';

import {
  useAdvertisementsQuery,
  useUpdateAdvertisementClickCountMutation,
} from '@/entities/advertisements';
import { Skeleton } from '@/shared/Components';
import Advertisement from '@/features/Advertisement';
import { useDeviceCheck } from '@/shared/hooks';

type AdvertisementLocation =
  | 'content_detail_1'
  | 'content_detail_2'
  | 'content_detail_3';

interface AdvertisementProps {
  location: AdvertisementLocation;
}

const AdvertiseContent = ({ location }: AdvertisementProps) => {
  const { data, isLoading, isError } = useAdvertisementsQuery({ location });
  const { mutate: updateAdvertisementClickCount } =
    useUpdateAdvertisementClickCountMutation();

  if (isLoading) {
    if (location === 'content_detail_1')
      return <Skeleton className="h-[400px] w-[248px]" />;

    if (location === 'content_detail_2')
      return <Skeleton className="h-[200px] w-[248px]" />;

    return <Skeleton className="h-[280px]" />;
  }

  if (!data || isError) return null;

  const { id, link, imgSrc } = data;

  const props = {
    imgSrc,
    link,
    onClick: () => updateAdvertisementClickCount({ id }),
  };

  if (location === 'content_detail_1')
    return <Advertisement variant="248x400" {...props} />;
  if (location === 'content_detail_2')
    return <Advertisement variant="248x200" {...props} />;
  if (location === 'content_detail_3')
    return <Advertisement variant="744x160" {...props} />;

  return null;
};

const Advertise = ({ location }: AdvertisementProps) => {
  const { isDesktop, isLoading } = useDeviceCheck();

  if (!isDesktop || isLoading) return null;

  return <AdvertiseContent location={location} />;
};

export default Advertise;
